import { useEffect, useState } from "react";
import SineWave from "../components/SineWave";
import { useNavigate } from "react-router-dom";

const Radio = () => {

    const [a, setA] = useState(0); //Fase vertical
    const [b, setB] = useState(6); //Amplitude
    const [c, setC] = useState(1); //Frequencia
    const [d, setD] = useState(1); //Horizontal

    const [enigma1, setEnigma1] = useState(false);
    const [enigma2, setEnigma2] = useState(false);

    const navigate = useNavigate();


    useEffect(() => {

        if(
            a === 0 &&
            b === 2 &&
            c === 3 &&
            d === 6
        ) {
               setEnigma1(true)
               setEnigma2(false)
        } else{
            setEnigma1(false)
        }

        if(
            a === 1 &&
            b === 2 &&
            c === 3 &&
            d === 4
        ) {
            navigate("/console")
        } else{
        }

        if(
            a === 3 &&
            b === 2 && 
            c === 6 && 
            d === 1
        ){
            setEnigma2(true);
            setEnigma1(false)
        } else{
            setEnigma2(false)
        }


    }, [a,b,c,d, navigate])

    useEffect(() => {

        //tocar Musica

    }, [enigma1])

    return (
        <div style={{
            width: "100vw",
            height: "100vh",
            background : "black",
            margin: 0,
            padding: 0,
            overflow: "hidden",
            display: "flex",
            justifyItems: "center",
            alignItems: "center",
            justifyContent: "center",
            fontFamily: 'VT323',
            position: 'relative'
        }}>
            <SineWave a={a*25} b={b*10} c={c/100} d={d*25} />
            
            <div style={{ 
                position: 'absolute', top: 10, left: 10, zIndex: 100, color: 'white', display: 'flex', flexDirection: 'column', gap: '10px',
                background: "url('./layout-radio-ofc.png')",
                backgroundSize: "cover",
                "aspectRatio": "6 / 8",
                "fontSize" : "2rem",
                fontWeight: "800",
                padding: "5rem",
                margin: "2rem"
            }}>
                <label style={{display: 'flex', flexDirection : 'row', gap: '1rem'}}>
                    A: <input type="range" min="1" max="6" value={a} onChange={e => setA(Number(e.target.value))} className="radioRangeInput" /> {a}
                    <input type="number" min="1" max="6" value={a} onChange={e => setA(Number(e.target.value))} className="radioInput" />
                </label>
                <label style={{display: 'flex', flexDirection : 'row', gap: '1rem'}}>
                    B: <input type="range" min="1" max="6" value={b} onChange={e => setB(Number(e.target.value))} className="radioRangeInput" /> {b}
                    <input type="number" min="1" max="6" value={b} onChange={e => setB(Number(e.target.value))} className="radioInput" />
                </label>
                <label style={{display: 'flex', flexDirection : 'row', gap: '1rem'}}>
                    C: <input type="range" min="1" max="6" step="1" value={c} onChange={e => setC(Number(e.target.value))} className="radioRangeInput" /> {c}
                    <input type="number" min="1" max="6" value={c} onChange={e => setC(Number(e.target.value))} className="radioInput" />
                </label>
                <label style={{display: 'flex', flexDirection : 'row', gap: '1rem'}}>
                    D: <input type="range" min="1" max="6" step="1" value={d} onChange={e => setD(Number(e.target.value))} className="radioRangeInput" /> {d}
                    <input type="number" min="1" max="6" value={d} onChange={e => setD(Number(e.target.value))} className="radioInput" />
                </label>
            </div>

            {
                enigma1 ? 
                    <div style={{position: 'absolute', top: 0, left:0, width: '100%', height: '100%', color: 'white', fontSize: '1.5rem'}}>
                        <div className="modal-area">
                            <div className="close-button" onClick={() => setEnigma1(false)}>X</div>
                            <div className="modal-content" style={{textAlign: 'justify'}}>
                                <p>
                                    Bom dia, moradores de Planaltina!
                                    <br/>
                                    <br/>
                                    A Diretoria Unificada de Reconstrução Nacional agradece o seu empenho como cidadão.
                                    <br/>
                                    <br/>
                                    Caso escutem transmissões não alinhadas ao padrão harmônico nacional, reportem
                                    <br/>
                                    imediatamente ao Setor de Controle de Ressonância.
                                    <br/>
                                    <br/>
                                    A reconstrução depende de vocês.
                                </p>
                            </div>
                        </div>
                    </div>
                : 
                enigma2 ? 
                    <div style={{position: 'absolute', top: 0, left:0, width: '100%', height: '100%', color: 'white', fontSize: '1.5rem'}}>
                        <div className="modal-area">
                            <div className="close-button" onClick={() => setEnigma2(false)}>X</div>
                            <div className="modal-content" style={{textAlign: 'justify'}}>
                                <p>
                                    ...- . -. .... .- / .--. .- .-. .- / .- -. --.. --- .-.. 
                                </p>
                            </div>
                        </div>
                    </div>
                : <></>
            }

            {/* Seno f(x) = a + b *sen(c.x + d)  desenhar seno*/}

            <img src="/aparato_gif3.gif" width={"30%"} height={"30%"} style={{}} className="misterio" alt="Radio Misterio">

            </img>

            {/* {Array.from({ length: 4 }, (_, i) => (
                <div key={i} className="misterio" style={{
                    position: "absolute",
                    top: `${1 + i * 5}rem`,
                    left: 0,
                    fontSize: '5rem',
                    WebkitTapHighlightColor: 'red',
                    textWrap: 'nowrap'
                }}>
                    {"SHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHH "}
                    <br></br>
                    {"SHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHH "}
                </div>
            ))}

            {Array.from({ length: 4 }, (_, i) => (
                <div key={i} className="misterio" style={{
                    position: "absolute",
                    top: `${50 + i * 5}rem`,
                    left: 0,
                    fontSize: '5rem',
                    WebkitTapHighlightColor: 'red',
                    textWrap: 'nowrap'
                }}>
                    {"Alguem me escuta?"}
                </div>
            ))} */}

        </div>
    )
}

export default Radio;